import { Component, OnInit } from '@angular/core';
import { AppServiceService } from '../../app-service.service';
import { UiService } from '../../ui.service';
import { WindowService } from '../../window.service';

@Component({
  selector: 'app-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.scss']
})
export class LeftSideComponent implements OnInit {
  title:string;
  transparent:boolean;
  arrow:boolean;
  logoWhite:boolean;
  showTitle:boolean = false;
  externalButton:boolean;
  showLeftPanel:boolean;
  imageScreen:boolean = false;
  logoHide:boolean = false;
  themeDir:string = '123';

  //left panel function
  //post colection
  showFullImage(){
    if(this.imageScreen){
      this.app.fullImageCollection.next(false);
      this.app.activeMenu.next(true);
    }else{
      this.app.fullImageCollection.next(true);
      this.app.activeMenu.next(false);
    }
    this.logoHide = !this.logoHide;
    this.imageScreen = !this.imageScreen;
  }

  constructor(
    private app:AppServiceService, 
    private UI:UiService,
    private win: WindowService) {
      this.themeDir = this.win.nativeWindow().api_settings.template;
  }

  ngOnInit() {
    this.UI.getWidthPanel();
    this.app.transparent.subscribe(data => {
      this.transparent = data;
    });
    this.app.arrow.subscribe(data => {
      this.arrow = data;
    });
    this.app.logoWhite.subscribe(data => {
      this.logoWhite = data;
    });
    this.app.titleLeftPanel.subscribe(data => {
      this.showTitle = data;
    });
    this.app.externalButton.subscribe(data => {
      this.externalButton = data;
    });
    this.app.showLeftPanel.subscribe(data => {
      this.showLeftPanel = data;
    });
    this.app.title.subscribe(data => {
      this.title = data;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/common/left-side/left-side.component.ts